import {message} from "antd";
import {isNull} from "../../utils/utils";
import {C240SlideStatus, queueActions, queueColorMap, queueLimits, queueOperationType} from "../../utils/const";
import {updateQueueState} from "../../redux_actions/c240_device_status.action";
import _ from "lodash";
import {RegionSelectionConstants} from "../../redux_constants/region_selection.constant";
import {get_response} from "../../helper/request";

export let DUMMY_RESPONSE_SCANNER_PROPS= {
    "data": {
        "rackSize": 4,
        "numberOfRacks": 2,
        "cassetteSize": 6,
        "isObjectiveSwitcherPresent": false,
        "allowScanOutputFormatChange": false,
        "allowObjectiveChange": false,
        "defaultConfig": {
            "selectedPoints": null,
            "slot": null,
            "tray": null,
            "rack": null,
            "specimenType": "HNE_TISSUE",
            "objectiveType": "FORTY_X",
            "scanOutputFormat": "JPG",
            "slideName": "",
            "doTilingOnly": false,
            "doTilingAfterScan": false,
            "zstackLevels": 10,
            "zstackStepSize": 0.1
        }
    },
    "status": 200,
    "statusText": "OK",
    "headers": {
        "connection": "keep-alive",
        "content-length": "462",
        "content-type": "application/json",
        "date": "Sun, 23 Jan 2022 19:34:19 GMT",
        "server": "WSGIServer/0.2 CPython/3.6.9",
        "vary": "Cookie, Origin, Accept-Encoding",
        "x-frame-options": "SAMEORIGIN",
        "x-powered-by": "Express"
    },
    "config": {
        "url": "/server/devices/1/settings/get_scanner_properties",
        "method": "get",
        "headers": {
            "Accept": "application/json, text/plain, */*"
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1
    },
    "request": {}
};

export const NO_OP = () => {};

export const getIndexInQueue = (rack, tray, slide, taskType, currQueue) => {
    let len = currQueue.length;
    for (let i = 0; i < len; i++) {
        let currTask = currQueue[i];
        if (currTask.taskType === taskType && currTask.rack === rack && currTask.slide === slide && currTask.tray === tray) {
            return i;
        }
    }
    return -1;
}

export const getLastEntryOfSlideInQueue = (rack, tray, slide, currQueue) => {
    let len = currQueue.length;
    let indexFound = -1;
    for (let i = 0; i < len; i++) {
        let currTask = currQueue[i];
        if (isNull(currTask)) continue;
        if (currTask.rack === rack && currTask.slide === slide && currTask.tray === tray) {
            indexFound = i;
        }
    }
    return indexFound;
}

export const appendToQueue = (rack, tray, slide, slideType, taskType, actionType, queueState, dispatch) => {
    let queueData = null;
    if (actionType === queueActions.ADD) {
        let newQueueState = JSON.parse(JSON.stringify(queueState));
        let newQueue = newQueueState.queue;
        //Append the new scan at the end
        let taskToAppend = {rack: rack, slide: slide, slideType: slideType, taskType: taskType, tray: tray};
        newQueue.push(taskToAppend);
        queueData = newQueueState;
    }

    dispatch(updateQueueUIUtility(rack, tray, slide, taskType, actionType,
        queueData, queueState));
}

export const updateQueueUIUtility = (rack, tray, slide,
                                     taskType, operationType,
                                     queueData = null, queueState = null, disableQueueInteraction = null) => (dispatch) => {

    let currQueueState;
    let currQueue;
    let index = -1;

    if (operationType === queueActions.ADD) {
        index = queueData.queue.length - 1;
        currQueueState = JSON.parse(JSON.stringify(queueData));
        currQueue = currQueueState.queue;
    } else {
        currQueueState = JSON.parse(JSON.stringify(queueState));
        currQueue = currQueueState.queue;
        index = getIndexInQueue(rack, tray, slide, taskType, currQueue);
    }

    let intermediateQueueState = JSON.parse(JSON.stringify(currQueueState));
    let intermediateQueue = intermediateQueueState.queue;

    if (operationType === queueActions.PRIORITISE) {
        if (index !== -1) {
            intermediateQueue[index].queueColorMap = queueColorMap.PRIORITISE;
            currQueue.splice(queueLimits.ALTER_TASK_ORDER, 0, currQueue[index]);
            currQueue.splice(index + 1, 1);
        }
    } else if (operationType === queueActions.REMOVE) {
        if (index !== -1) {
            intermediateQueue[index].queueColorMap = queueColorMap.REMOVE;
            currQueue.splice(index, 1);
        }
    } else if (operationType === queueActions.ADD) {
        intermediateQueue[index].queueColorMap = queueColorMap.ADD;
    } else if(operationType === queueActions.DEPRIORITISE){
        if(index !== -1){
            intermediateQueue[index].queueColorMap = queueColorMap.REMOVE;
            currQueue.splice(index+2, 0, currQueue[index]);
            currQueue.splice(index,1);
        }
    } else if(operationType === queueActions.REMOVE_PREVIEW_CALIBRATION) {
        intermediateQueueState["ongoing"] = null;
    }
    dispatch(updateQueueState(intermediateQueueState));
    if(disableQueueInteraction){
        disableQueueInteraction(true);
    }

    setTimeout(() => {

        //Second Step of Animation if action is PRIORITISE:
        if (operationType === queueActions.PRIORITISE) {
            let phasedQueueState = JSON.parse(JSON.stringify(currQueueState));
            let phasedQueue = JSON.parse(JSON.stringify(currQueue));
            phasedQueue[queueLimits.ALTER_TASK_ORDER].queueColorMap = queueColorMap.ADD;
            phasedQueueState.queue = phasedQueue;

            setTimeout(() => {
                dispatch(updateQueueState(phasedQueueState));
                if(disableQueueInteraction){
                    disableQueueInteraction(false);
                }
            }, 100);
        }
        else if(operationType === queueActions.DEPRIORITISE){
            let phasedQueueState = JSON.parse(JSON.stringify(currQueueState));
            let phasedQueue = JSON.parse(JSON.stringify(currQueue));
            phasedQueue[index+1].queueColorMap = queueColorMap.ADD;
            phasedQueueState.queue = phasedQueue;

            setTimeout(() => {
                dispatch(updateQueueState(phasedQueueState));
                if(disableQueueInteraction) {
                    disableQueueInteraction(false);
                }
            },100);
        }

        if (operationType !== queueActions.REMOVE_PREVIEW_CALIBRATION) {
            currQueueState.queue = currQueue;
            dispatch(updateQueueState(currQueueState));
        }

        if (operationType !== queueActions.PRIORITISE) {
            if(disableQueueInteraction){
                disableQueueInteraction(false);
            }
        }
    }, 100);

}


function callScannerHelper(url, errcallback, show_info, callback) {
    get_response(url)
        .then(response => {
            if (response.status !== 200) {
                if (errcallback !== null) {
                    errcallback(response.status, null);
                }
                console.error("Failed to Queue Prev");
            } else {
                console.debug(response.data);
                if (show_info) {
                    message.info(response.data.message);
                }
                console.log("calling back: ");
                if (callback !== null) {
                    callback(response.data);
                }
            }
        })
        .catch(err => {
            if (errcallback !== null) {
                errcallback(-1, err);
            }
            console.log(err);
        })
}

export const queueScan = ( options = "", callback = null, show_info = true, errcallback = null) => {
    // callback is called on 200 response code with response.data as argument
    let url = `/server/pre_process_scano/1/api~hts~queue_scan` + "/" + options + "&sendUserId=true";
    console.debug("path ", url, options);
    callScannerHelper(url, errcallback, show_info, callback);
};


export const callScannerServer = (endpoint, options = "", callback = null, show_info = true, errcallback = null) => {
    // callback is called on 200 response code with response.data as argument
    let url = `/server/scano/1/api~hts~` + endpoint + "/" + options;
    console.debug("path ", url, options);
    callScannerHelper(url, errcallback, show_info, callback)
};

// Find difference between two object (deep check)
export const getObjectDifference = (object1, object2) => {
    return _.transform(object1, (result, value, key) => {
        if (!_.isEqual(value, object2[key])) {
            if (!_.isFunction(value) && !_.isFunction(object2[key])) {
                result[key] = _.isObject(value) && _.isObject(object2[key])
                    ? getObjectDifference(value, object2[key])
                    : value;
            }
        }
    });
}

export const getRackTrayFromCassetteKey = (cassetteKey) => {
    let rack = parseInt(cassetteKey.split("T")[0].split("R")[1]);
    let tray = parseInt(cassetteKey.split("T")[1]);
    return {rack, tray};
}

export const getDummyPreviewObject = (slideKey) => {
    return {
        response: null,
        slideName: "Something Wrong",
        slideState: C240SlideStatus.INITIAL,
        speed: "MEDIUM",
        specimenType: "IHC",
        scanOutputFormat: "JPG",
        stepSize: 1,
        zStackLevels: 10,
        numWBCToScan: -1,
        objectiveType: "FORTY_X",
        message: "",
        actionOngoing: false,
        doTilingOnly: false,
        doTilingAfterScan: false,
        slideKey: slideKey
    };
}

export const getPreviewObject = (slideKey, slideInfo, previewSlotInfo) => {
    let speed = (slideInfo || {}).scanSpeed;
    if (!isNull(previewSlotInfo) && !isNull(previewSlotInfo["speed"])) {
        speed = previewSlotInfo["speed"];
    }
    return {
        response: slideInfo,
        slideName: (slideInfo || {}).slideName,
        status: RegionSelectionConstants.FETCHED_IMAGE,
        speed: speed,
        specimenType: (slideInfo || {}).specimenType,
        scanOutputFormat: (slideInfo || {}).scanOutputFormat,
        stepSize: (slideInfo || {}).zstackStepSize,
        zStackLevels: (slideInfo || {}).zstackLevels,
        objectiveType: (slideInfo || {}).objectiveType,
        message: "",
        actionOngoing: false,
        doTilingOnly: false,
        doTilingAfterScan: false,
        slideKey: slideKey,
        dropDistancePoint: (slideInfo || {}).dropDistancePoint,
        numWBCToScan: (slideInfo || {}).numWBCToScan,
        scanningProfile: ((slideInfo || {}).scanningProfile || {}).id || "",
    };
}

export const comparePropsAndState = (prevPros, currProps, prevState, currState) => {
    const propsDiff = getObjectDifference(prevPros, currProps);
    const stateDiff = getObjectDifference(prevState, currState);
    return !(Object.keys(propsDiff).length === 0 && Object.keys(stateDiff).length === 0);
}